import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';

// Tenant portal uses its own token (separate from operator apiClient).
const tenantHeaders = () => {
  const token = localStorage.getItem('tenantAccessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const tenantPaymentService = {
  // Ask the backend (processor-agnostic) for a charge to confirm client-side.
  createPayIntent: (rentalId, amount) =>
    axios.post(
      `${API_URL}/api/tenant/pay-intent`,
      { rental_id: rentalId, amount },
      { headers: tenantHeaders() }
    ),

  // One-click "Pay all": the backend computes the tenant's total outstanding
  // balance server-side and returns a single charge; the webhook spreads it
  // across all their open invoices. No amount is sent from the client.
  createPayAllIntent: () =>
    axios.post(
      `${API_URL}/api/tenant/pay-all-intent`,
      {},
      { headers: tenantHeaders() }
    ),

  // Report the client-side outcome of a pay attempt (telemetry). Fire-and-
  // forget — never block the pay flow on it.
  reportPayAttempt: (attemptId, outcome, detail) => {
    if (!attemptId) return Promise.resolve();
    return axios.post(
      `${API_URL}/api/tenant/pay-attempt/${attemptId}`,
      { outcome, detail: detail ? String(detail).slice(0, 500) : undefined },
      { headers: tenantHeaders() }
    ).catch(() => {});
  },

  // Begin saving a card for autopay (returns a SetupIntent client secret).
  setupAutopay: () =>
    axios.post(
      `${API_URL}/api/tenant/autopay/setup`,
      {},
      { headers: tenantHeaders() }
    ),

  disableAutopay: () =>
    axios.post(
      `${API_URL}/api/tenant/autopay/disable`,
      {},
      { headers: tenantHeaders() }
    ),
};

export default tenantPaymentService;
